export default "__VITE_ASSET__9b60687f__"